module.exports = __webpack_public_path__ + "img/logo-account.0a61c55f.svg";